import axios from 'axios';

window.host = process.env.MIX_APP_URL;

const instance = axios.create({
  baseURL: host,
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
  },
});

instance.interceptors.response.use(
  response => response, // Do something with response data
  function (err) {
    if (err.__CANCEL__) return Promise.reject(err);

    if (err.response.status === 403) {
      window.globalEventBus.$swal('Woops', err.response.data.message, 'error');
      window.globalEventBus.$snotify.warning('Vous n\'êtes pas authorisé a faire ça...', 'Woops');
    }
    else if (err.response.status === 422) {
      Event.fire('errors', err.response.data.errors);
      window.globalEventBus.$snotify.error('La formulaire n\'est pas complet', 'Woops');
    }
    else if (err.response.status === 500) {
      console.error(err.response);
      window.globalEventBus.$snotify.error('Une erreur est survenue...', 'Woops');
    }

    return Promise.reject(err);
  },
);

export default instance;
